import React from "react";
import MenuIcon from "@material-ui/icons/Menu";
import Videocam from "@material-ui/icons/Videocam";
import LiveHelpIcon from "@material-ui/icons/LiveHelp";
import MailIcon from "@material-ui/icons/Mail";
import YoutubeSearchedForIcon from "@material-ui/icons/YoutubeSearchedFor";
import ExitToAppIcon from "@material-ui/icons/ExitToApp";
import LocalLibraryIcon from "@material-ui/icons/LocalLibrary";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setNotifications, userSignOut, setUnseenNotifCount } from "../../../../redux/actions";
import { CardMembershipOutlined, LiveHelp } from "@material-ui/icons";
import { removeProfile } from "../../../../redux/actions/index";
import { fetchAllContent } from "../../../../redux/dataFetchers/contentApi";
import "./DeskSide.css";

function SideBar() {
  const history = useHistory();
  const isAuthenticated = useSelector(
    (state) => state.authUser.isAuthenticated
  );
  const dispatch = useDispatch();

  const Logout = () => {
    localStorage.removeItem("token");
    dispatch(userSignOut());
    dispatch(removeProfile({}));
    dispatch(fetchAllContent());
    dispatch(setNotifications([]));
    dispatch(setUnseenNotifCount(0));
    history.push("/");
  };

  return (
    <div>
      <div id="mySidenav" className="sidenav">
        <div className="nav">
          <CardMembershipOutlined
            style={{ color: "#b32800" }}
            fontSize="small"
          />
          <p onClick={() => history.push("")}>Feed</p>
        </div>
        <div className="nav">
          <Videocam style={{ color: "#b32800" }} fontSize="small" />
          <p onClick={() => history.push("/videos")}>Videos</p>
        </div>
        <div className="nav">
          <LiveHelp style={{ color: "#b32800" }} fontSize="small" />
          <p onClick={() => history.push("/quiz")}>Quiz</p>
        </div>
        <div className="nav">
          <MailIcon style={{ color: "#b32800" }} fontSize="small" />
          <p onClick={() => history.push("/fellowbot")}>FellowMonk - Bot</p>
        </div>
        <div className="nav">
          <YoutubeSearchedForIcon
            style={{ color: "#b32800" }}
            fontSize="small"
          />
          <p onClick={() => history.push("/fellowbot")}>Sourcing - Bot</p>
        </div>
        <div className="nav">
          <LocalLibraryIcon style={{ color: "#b32800" }} fontSize="small" />
          <p onClick={() => history.push("/articles")}>Library</p>
        </div>
        {isAuthenticated ? (
          <div className="nav">
            <ExitToAppIcon style={{ color: "#b32800" }} fontSize="small" />
            <p onClick={Logout}>Logout</p>
          </div>
        ) : (
          ""
        )}
      </div>

      {/* <div>
            <MenuIcon fontSize="large" style={{fontSize:'30px',cursor:'pointer', marginLeft: '100px'}} onClick={OpenNav} />
            </div> */}
    </div>
  );
}

export default SideBar;
